var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "dash-number-box bg-white" },
    [
      _c("q-card-main", [
        _c("div", { staticClass: "row gutter-x-md" }, [
          _c(
            "div",
            { staticClass: "col-auto" },
            [
              _c("q-icon", {
                staticClass: "circle bg-red-1 text-red-5 q-pa-sm q-mt-xs",
                staticStyle: { "font-size": "1.75rem" },
                attrs: { name: "timer" }
              })
            ],
            1
          ),
          _c("div", { staticClass: "col" }, [
            _c("span", { staticClass: "dash-number-box__value--small" }, [
              _vm._v(_vm._s(_vm.formatMoney(_vm.amount, _vm.currency, 0, 0)))
            ]),
            _c("h2", { staticClass: "dash-number-box__heading--small" }, [
              _vm._v(
                _vm._s(
                  _vm.$tc("statistics_overdue_invoices", _vm.number, {
                    number: _vm.number
                  })
                )
              )
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }